// extracted by mini-css-extract-plugin
module.exports = {"section":"grid_section__I0FSp","column":"grid_column__gKBIv","line":"grid_line__qLbxR","slide":"grid_slide__sxKRq"};